import { render } from "./CashierSettings.vue?vue&type=template&id=03361eda"
import script from "./CashierSettings.vue?vue&type=script&lang=js"
export * from "./CashierSettings.vue?vue&type=script&lang=js"
script.render = render

export default script